/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RemovalPoint} from '../../../_models/removal-point';

@Component({
  selector: 'app-dialog-removal-point-disable',
  templateUrl: './dialog-removal-point-disable.component.html',
  styleUrls: ['./dialog-removal-point-disable.component.scss']
})
export class DialogRemovalPointDisableComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    public dialogRef: MatDialogRef<DialogRemovalPointDisableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemovalPoint
  ) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(res: boolean): void {
    this.dialogRef.close(res);
  }

}
